import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import { useAuthLifecycleLogging } from '../../utils/authLifecycleLogger';
import usePageView from '../../hooks/usePageView';
import { ANALYTICS_EVENTS } from '../../constants/analyticsEvents';

const ClerkRegister = () => {
  usePageView(ANALYTICS_EVENTS.AUTH_REGISTER_VIEWED);
  // Diagnostic: tracks mount / unmount / page-reload events on the registration
  // page so we can attribute duplicate verification-code emails to either a
  // React remount (StrictMode-style) or a page refresh mid-flow. Safe to
  // remove once the duplicate-email cause is confirmed and resolved.
  useAuthLifecycleLogging('ClerkRegister');

  return (
    <div className="min-h-screen flex items-center justify-center bg-[linear-gradient(135deg,var(--bg-main)_0%,var(--bg-card)_50%,var(--bg-main)_100%)]">
      <SignUp
        routing="path"
        path="/clerk-register"
        signInUrl="/clerk-login"
        fallbackRedirectUrl="/dashboard"
      />
    </div>
  );
};

export default ClerkRegister;
